import { render, staticRenderFns } from "./TPCustomerApply.vue?vue&type=template&id=5a47eb50&scoped=true"
import script from "./TPCustomerApply.vue?vue&type=script&lang=js"
export * from "./TPCustomerApply.vue?vue&type=script&lang=js"
import style0 from "./TPCustomerApply.vue?vue&type=style&index=0&id=5a47eb50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a47eb50",
  null
  
)

export default component.exports